import {MediaDevicesStorageData, mediaDevicesStore} from 'services';

import {useObservable} from './observable';

export function useMediaDevices(): [MediaDevicesStorageData, (mediaDevices: MediaDevicesStorageData) => void] {
    const mediaDevices = useObservable(mediaDevicesStore);
    return [mediaDevices, mediaDevicesStore.setValue.bind(mediaDevicesStore)];
}